import logError from './logError'

export default function ignoreAsync<T extends (...args: any[]) => Promise<void>> (fn: T): (...params: Parameters<T>) => void {
  return (...args) => {
    fn(...args).catch((error) => {
      logError(new Error(`Async task ${fn.name} rejected: ${String(error)}`, { cause: error }))
    })
  }
}
